export default __webpack_public_path__ + "static/media/GB.fabc96ce.svg";